import(/* webpackMode: "eager", webpackExports: ["ShopPageClient"] */ "/workspace/src/components/public/shop-page-client.tsx");
